<template>
  <v-container class="promotion p-0" fluid>
    <vue-headful :title="$t('promotion.title') + $t('title')"></vue-headful>
    <HkiaraceBannerFrame :src="require('../../../assets/special-offer.png')"
                         :label="$t('promotion.banner')">
      <v-container class="p-0">
        <v-row class="promotion-section-header"
               no-gutters>
          <v-col>{{ $t('promotion.shopping') }}</v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row v-if="isLoggedIn">
          <v-col cols="6" lg="3" md="4"
                 v-for="vendor in corporateVendors" :key="vendor.id"
                 class="promotion-cell">
            <div :style="getCorporateVendorStyle(vendor)"
                 @click="onCorporateVendorClick(vendor)"
                 class="promotion-cell-img animation-ease hover-scale"></div>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="d-flex justify-center">
            <div class="promotion-login-btn"
                 v-html="$t('promotion.login')"
                 @click="$router.push({name: 'login', query: {after: $route.path}})">
            </div>
          </v-col>
        </v-row>
        <v-row class="promotion-section-header"
               no-gutters>
          <v-col>{{ $t('promotion.special_offer') }}</v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="6" lg="3" md="4"
                 v-for="promotion in promotions" :key="promotion.id"
                 class="promotion-cell">
            <div :style="getPromotionStyle(promotion)"
                 @click="showPromotionContent(promotion)"
                 class="promotion-cell-img animation-ease hover-scale"></div>
          </v-col>
        </v-row>
      </v-container>
    </HkiaraceBannerFrame>
  </v-container>
</template>

<script>
import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";
import {HOST} from "@/main";
import {computed, onMounted, ref, watch} from "@vue/composition-api";
import CorporateVendorDetailModal from "@/components/corporateVendor/CorporateVendorDetailModal";

export default {
  name: 'Promotion',
  components: {HkiaraceBannerFrame},
  setup(props, {root}) {
    const promotions = ref([]);
    const getPromotions = function () {
      root.$callAPI('hkiarace/promotion/', {}, function (response) {
        promotions.value = response.body.promotions;
      });
    };
    const getPromotionStyle = function (promotion) {
      return {
        'background-image': `url("${HOST}static/` + promotion.icon + '")',
      }
    }
    const showPromotionContent = function (promotion) {
      window.open('/api/static/' + promotion.content, '_blank');
      root.$callAPI('hkiarace/promotion/view/', {id: promotion.id}, function () {});
    }

    const isLoggedIn = computed(() => {
      return !!root.$store.state.user.id;
    })
    watch(() => isLoggedIn.value, (newValue) => {
      if (newValue) {
        getCorporateVendors();
      }
    })
    const corporateVendors = ref([]);
    const getCorporateVendors = function () {
      root.$callAPI('hkiarace/corporate_vendor/', {}, function (response) {
        corporateVendors.value = response.body.vendors;
      });
    };
    const getCorporateVendorStyle = function (vendor) {
      return {
        'background-image': `url("${HOST}static/` + root.$localeGet(vendor, 'icon') + '")',
      }
    };
    const onCorporateVendorClick = async function (vendor) {
      if (vendor.popup_enabled) {
        await root.$dialog.showAndWait(CorporateVendorDetailModal, {
          width: '80vw',
          height: root.$vuetify.breakpoint.smAndDown ? '100vh' : null,
          fullscreen: root.$vuetify.breakpoint.smAndDown,
          showClose: root.$vuetify.breakpoint.smAndDown,
          vendor,
        })
      } else {
        let url = vendor.url;
        url = url.match(/^https?:/) ? url : '//' + url;
        window.open(url, '_blank');
        root.$callAPI('hkiarace/corporate_vendor/view/', {id: vendor.id}, function () {});
      }
    }

    onMounted(() => {
      getPromotions();
      if (isLoggedIn.value) {
        getCorporateVendors();
      }
    })

    return {
      promotions,
      getPromotions,
      getPromotionStyle,
      showPromotionContent,
      isLoggedIn,
      corporateVendors,
      getCorporateVendorStyle,
      onCorporateVendorClick,
    }
  }
}
</script>

<style lang="less">
.promotion {
  .promotion-cell {
    .promotion-cell-img {
      cursor: pointer;
      background-color: white;
      width: 100%;
      padding-top: 100%;
      background-size: 80%;
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  .promotion-login-btn {
    background-color: var(--v-primary-base);
    border-radius: 100px;
    padding: 12px 24px;
    max-width: 372px;
    color: white;
    font-weight: bold;
    font-size: 150%;
    cursor: pointer;
  }

  .promotion-section-header {
    font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
    font-weight: 400;
    color: rgba(142, 118, 91, 1);
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 2.25rem;
  }
}
</style>
